import React, { useContext, useState } from "react";
import { Backdrop } from "@mui/material";

import { PermissionContext, RolePermissions } from "../../../../../appContext";
import { PermisionDenied } from "../../common/commonComponents";
import ALoader from "views/pages/manage/common/a-loader";
import { pages } from "../../common/constant";

import SubjectTable from "./SubjectTable";

const SubjectMaster = () => {
  const permissions = useContext(PermissionContext);
  const userPermissions = RolePermissions(
    permissions,
    pages["subjectMaster"]["id"]
  );

  const [isLoading, setIsLoading] = useState(false);

  return userPermissions ? (
    <>
      <SubjectTable
        userPermissions={userPermissions}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />

      {isLoading && (
        <Backdrop
          open={isLoading}
          sx={(theme) => ({
            color: "#fff",
            zIndex: 2300,
          })}
        >
          <ALoader />
        </Backdrop>
      )}
    </>
  ) : (
    <PermisionDenied />
  );
};

export default SubjectMaster;
